/*
function colorHeaderMenu(){
	//console.log('header menu color');
	var docViewTop = $(window).scrollTop();
	var mainBannerHeight=$('.main_banner ').height()-100;
	var colorMenu=$('.main_banner').data('colorMenu');
	var colorHeader=$('.main_banner').data('colorHeader');
	if($('.main_banner .item').length){
		colorMenu=$('.main_banner .item.active').data('colorMenu') ? $('.main_banner .item.active').data('colorMenu')  : '';
	}
	if($('.main_banner .item').length){
		colorHeader=$('.main_banner .item.active').data('colorHeader') ? $('.main_banner .item.active').data('colorMenu')  :  '';
	}
	if(docViewTop>=mainBannerHeight){
		$('#navbar-collapse-categories a').css('color','');		
		$('#navbar-collapse-main .navbar-right > li > a').css('color','');
		$('#site_header .navbar-default #navbar-collapse-main>.navbar-right>.form-group>input').css('color','');
		$('.ico-black').removeClass('hidden');
		$('.ico-white').addClass('hidden');
		if($('.cart-red').hasClass('hidden')){
			$('.cart-black').removeClass('hidden');
			$('.cart-white').addClass('hidden');
		}
		$('.navbar-brand').removeClass('hidden');
		$('.navbar-brand.white').addClass('hidden');
		$('.left-menu-sticky').removeClass('white');
	}else{
		if(colorHeader !== undefined){
			if(colorHeader.toUpperCase()=== "#FFF" || colorHeader.toUpperCase()=== "#FFFFFF"){
				$('.ico-white').removeClass('hidden');
				$('.ico-black').addClass('hidden');
				if($('.cart-red').hasClass('hidden')){
					$('.cart-black').addClass('hidden');
					$('.cart-white').removeClass('hidden');
				}
				$('.navbar-brand').addClass('hidden');
				$('.navbar-brand.white').removeClass('hidden');	
				$('.left-menu-sticky').addClass('white');				
			}else{			
				$('.navbar-brand').removeClass('hidden');
				$('.navbar-brand.white').addClass('hidden');
				$('.left-menu-sticky').removeClass('white');
			}

			if(colorHeader.toUpperCase()=== "#000" || colorHeader.toUpperCase()=== "#000000"){
				$('.ico-black').removeClass('hidden');
				$('.ico-white').addClass('hidden');
				if($('.cart-red').hasClass('hidden')){
					$('.cart-white').addClass('hidden');
					$('.cart-black').removeClass('hidden');
				}
				$('.navbar-brand').removeClass('hidden');
				$('.navbar-brand.white').addClass('hidden');
			}
		}
		
		$('#navbar-collapse-categories a').css('color',colorMenu);
		$('#navbar-collapse-main .navbar-right > li > a').css('color',colorHeader);
		$('#site_header .navbar-default #navbar-collapse-main>.navbar-right>.form-group>input').css('color',colorHeader);
	}
}
function isScrolledIntoView(elem)
{
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top+150;
    var elemBottom = elemTop + $(elem).height()-150;
		//ALL VISIBLE
    //return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		//TOP VISIBLE
		return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
}
function ueImage(){
	//.banner_images img,
	//.double_images img,.category_double_images img
	$('.double_images img,.category_double_images img ').each(function(  ){
		var t=200;
		$(this).not('.ue-done').each(function( ){
			if(isScrolledIntoView($(this))){
					$(this).addClass('ue-done');
				$(this).removeClass('not-visible');
			}else{
				$(this).addClass('not-visible');
			}
		});
	});
}


$(document).ready(function(){
	if($('.manager_home').length == 0){
		ueImage();
	}
	if ($('.main_banner').length > 0 || $('.type_page_search_store').length > 0){
		colorHeaderMenu();
		$('#mainCarousel').bind('slid.bs.carousel',function(){
		colorHeaderMenu();
		});
	}
});
$(window).scroll(function() {
	if($('.manager_home').length == 0){
		ueImage();
	}
	if ($('.main_banner').length > 0 ){
		colorHeaderMenu();
	}
});

if($('.manager_home').length != 0){
	//alert('NOT Mobile');
	$('#homeIndicators a').click(function(){
		$('html,body').animate({
    	scrollTop: $($(this).attr('href')).offset().top
  	},800);
		$('#homeIndicators a').removeClass('active');
		$(this).addClass('active');
		$('.main_banner.active').removeClass('active');	
		//console.log($(this).attr('href').replace('#', ''));
		$($(this).attr('href')).addClass('active');
	});
	setTimeout(function(){
		var doneActive=true;
		$('.main_banner').each(function(){
			if($(this).offset().top == $(document).scrollTop()){
				$(this).addClass('active');
				$('#homeIndicators a[href="#'+$(this).attr('id')+'"]').addClass('active');
				 doneActive=false;
			}
		});
		if( doneActive){
			$('.main_banner').first().addClass('active');
			$('#homeIndicators a[href="#'+$('.main_banner').first().attr('id')+'"]').addClass('active');
		}
	},800);
	
	var lastScrollTop = 0;
	var onScrolling=false;
	if( !window.mobileAndTabletCheck()){
		
	}

	function scrollToNext(){
		
		var $next;
		$next = $('.main_banner.active').next('.main_banner');
		if($next.length != 0){
			$('.main_banner.active').removeClass('active');		
			$('html,body').stop().animate({ scrollTop: $next.offset().top	}, 1500);
			$next.addClass('active');
			$('#homeIndicators a').removeClass('active');
			$('#homeIndicators a[href="#'+$next.attr('id')+'"]').addClass('active');
		}
		return false;
	}
	function scrollToPrev(){
		var $prev;
		$prev = $('.main_banner.active').prev('.main_banner');
		if($prev.length != 0){
			$('.main_banner.active').removeClass('active');			
			$('html,body').stop().animate({ scrollTop: $prev.offset().top	}, 1500);
			$prev.addClass('active');
			$('#homeIndicators a').removeClass('active');
			$('#homeIndicators a[href="#'+$prev.attr('id')+'"]').addClass('active');
		}
		return false;
		}

	$('[data-zg-scrollTo="next"]').click(function(){
		//console.log('NEXT');
		var r=scrollToNext();
		setTimeout(function() {
				onScrolling = false;
		}, 800);
	});
	if($('.manager_home').length != 0 && !window.mobileAndTabletCheck()){
		
	}else{
		document.querySelector('body').style.overflow = "initial";
		$(document).scroll(function(){
			$('.main_banner').each(function(){
				if(isScrolledIntoView($(this))){
					$('#homeIndicators a').removeClass('active');					
					//console.log($(this).attr('id'));
					$('#homeIndicators').find('[href="#'+$(this).attr('id')+'"]').addClass('active');
				}
			});
		});
	}

	var xDown = null;                                                        
	var yDown = null;

	function getTouches(evt) {
		return evt.touches ||             // browser API
					evt.originalEvent.touches; // jQuery
	}                                                     

	function handleTouchStart(evt) {
		if(onScrolling == false && xDown ==null){
			const firstTouch = getTouches(evt)[0];                                      
			xDown = firstTouch.clientX;                                      
			yDown = firstTouch.clientY;     
		}
	};                                                

	function handleTouchMove(evt) {
			if ( ! xDown || ! yDown ) {
					return;
			}
			

			var xUp = evt.touches[0].clientX;                                    
			var yUp = evt.touches[0].clientY;

			var xDiff = xDown - xUp;
			var yDiff = yDown - yUp;


					if ( yDiff > 0 ) {
										
						//console.log('scroll touch');
							var r=scrollToNext();
							setTimeout(function() {
									onScrolling = false;
									$('html,body').stop();
							}, 1500);

					} else { 
						
						//console.log('scroll touch');
							var r=scrollToPrev();
							setTimeout(function() {
								onScrolling = false;
								$('html,body').stop();
							}, 1500);



					}                                                                 

			
			xDown = null;
			yDown = null;                                             
	};
}

*/

/*
// stiky header
$(window).scroll(function() {
	var scrollPos = $(document).scrollTop();
	if (scrollPos > 1){  
		$('body.page_home').addClass("sticky");
		$('a.dropdown-toggle').removeClass("white");
	}
	else{
		$('body.page_home').removeClass("sticky");
		$('a.dropdown-toggle').addClass("white");
	}	
});
*/

/*
//STICKY HEADER CHANGE BG
	var $stickyHeader=$('#site_header');
	var main_banner=false;
	
	// SET BANNER 100% HEIGHT
	function setImageBanner(){
		var $docHeight =  $( window ).height();
		$('.main_banner').css('height',$docHeight);
		
	}
	if($('.main_banner').length && $('.banner-exchange').length == 0){
		setImageBanner();
		main_banner=true;
	}
	function mainBanner(){
		if(main_banner){			
			var sticky = $('.main_banner').height();//+$stickyHeader.height();
			 if (window.pageYOffset > sticky) {
					$stickyHeader.addClass('white');
			}else{
				$stickyHeader.removeClass('white');
			}
		}else{
			if (window.pageYOffset > 0) {
				$stickyHeader.addClass('white');
			}else{
				$stickyHeader.removeClass('white');
			}
		}
	}
	$(window).scroll(function() {
		mainBanner();
	});
	
	$( window ).resize(function() {
		if($('.main_banner').length){
			setImageBanner();
		}
		
	});
	$(document).ready(function(){
			mainBanner();
	});
	$('#typeahead-search-button').on('click',function(e){
		if($('#product-finder .close').length){
				e.preventDefault();
				$('#product-finder .close').removeClass('close');
		}
	});
	// SEARCH MOBILE
	$('#typeahead-search-button-mobile').on('click',function(e){
		if($('#product-finder .close').length){
				e.preventDefault();
				$('#product-finder .close').removeClass('close');
		}
	});
	$('#searchToggle').on('click',function(e){
		$('.headerMobile').toggleClass('bkgWhite');							
		$('#searchForm').toggle('slow', function() {
			// complete
		});									
	});




// navMobile scroll event
		$( '.navMobile' ).scroll(function() {
			var scrollPos = $('.navMobile').scrollTop();
			if (scrollPos > 1){  
				$('.main-logo-container-fixed').removeClass("visible-xs");
				$('.main-logo-container-fixed').addClass("hidden");
				$('#nav-icon-close').css("display","none");
			}
			else{
				$('.main-logo-container-fixed').removeClass("hidden");
				$('.main-logo-container-fixed').addClass("visible-xs");
				$('#nav-icon-close').css("display","block");
			}	
		});


// Code to close automatically the mobile menu when the user clicks outside of it
		$(document).mouseup(function(e) 
		{
			var valueLeftNavMobile = $('[data-zg-role="navMobile"]').css('left');
				
			// It will only be closed when the navMobile is opened
			if( valueLeftNavMobile == "0px" ){
					var container = $('#navbar-collapse-categories-mobile');

					// if the target of the click isn't the container nor a descendant of the container
					if (!container.is(e.target) && container.has(e.target).length === 0) 
					{
							$('#nav-icon-close').click();
					}
			}
		});	





		
		
		//

// Carousel Settings - Home
	$( '.carousel' ).carousel( {} );
			// SWIPE CAROUSEL
			var $carousel = $( '.carousel' );
			if ( $carousel.length ) {
					$carousel.swiperight( function () {
							$( this ).carousel( 'prev' );
					} );
					$carousel.swipeleft( function () {
							$( this ).carousel( 'next' );
					} );
			}
	
*/


/*



	$('#typeahead-search-button').on('click',function(e){
		if($('#product-finder .close').length){
				e.preventDefault();
				$('#product-finder .close').removeClass('close');
		}
	});
	// SEARCH MOBILE
	$('#typeahead-search-button-mobile').on('click',function(e){
		if($('#product-finder .close').length){
				e.preventDefault();
				$('#product-finder .close').removeClass('close');
		}
	});
	$('#searchToggle').on('click',function(e){
		$('.headerMobile').toggleClass('bkgWhite');							
		$('#searchForm').toggle('slow', function() {
			// complete
		});									
	});

	// Mobile header scroll up and down
	$(function(){
			//Keep track of last scroll
			var lastScroll = 0;
			$(window).scroll(function(event){
					//Sets the current scroll position
					var st = $(this).scrollTop();
					//Determines up-or-down scrolling
					if (st > lastScroll){
						$(".headerMobile").removeClass("fixed");
						//$(".manager_account #site_main").removeClass("paddingTop");
					} 
					else {
						$(".headerMobile").addClass("fixed");
						//$(".manager_account #site_main").addClass("paddingTop");
					}
					//Updates scroll position
					lastScroll = st;
			});
   });
	
	
	$('.input_email').on( "focus", function(){
		$('.newsletter_block .input-group-btn').removeClass('hidden');
		$('.newsletter_block .checkbox').removeClass('hidden');
	});

*/


//STICKY HEADER CHANGE BG
/*
$(document).ready(function () {
	if ($('.main_banner').length) {
		var $stickyHeader = $('#site_header');
		$stickyHeader.addClass('trasparent');

		mainBanner();

		$(window).scroll(function () {
			mainBanner();
		});

		// Mouse enter: sempre visibile
		$stickyHeader.on('mouseenter', function () {
			$stickyHeader.removeClass('trasparent');
		});

		// Mouse leave: torna trasparente solo se sopra main_banner e nessun dropdown aperto
		$stickyHeader.on('mouseleave', function () {
			var isAboveSticky = window.pageYOffset <= $('.main_banner').height();
			var hasActiveDropdown = $stickyHeader.find('.dropdown.open').length > 0;

			if (isAboveSticky && !hasActiveDropdown) {
				$stickyHeader.addClass('trasparent');
			}
		});
	}
});

function mainBanner() {
	var $stickyHeader = $('#site_header');
	var sticky = $('.main_banner').height();
	var hasActiveDropdown = $stickyHeader.find('.dropdown.open').length > 0;

	// Se c'è un dropdown aperto, non diventare trasparente
	if (hasActiveDropdown) {
		$stickyHeader.removeClass('trasparent');
		return;
	}

	if (window.pageYOffset > sticky) {
		$stickyHeader.removeClass('trasparent');
	} else {
		$stickyHeader.addClass('trasparent');
	}
}

*/


$(document).ready(function() {
    const $mainBanner = $('.main_banner');

    if ($mainBanner.length) {
        const $stickyHeader = $('#site_header');
        let isMouseOverHeader = false;

        const $logoImg = $stickyHeader.find('.navbar-brand img');
        const $textElements = $stickyHeader.find('.main-menu-lev1 > li > a, .dropdown-lang > a, .wish .number, .cart .number');
        const $svgPaths = $stickyHeader.find('.navbar-right svg path');
        const $hamburgerSpans = $stickyHeader.find('#nav-icon span');

        const logoData = $mainBanner.data('color-logo');
        const logoColorType = (logoData) ? String(logoData).trim() : null;
        
        const headerColor = $mainBanner.data('color-header');

        const updateHeaderState = () => {
            const isAboveBanner = window.pageYOffset <= $mainBanner.height();
            const hasActiveDropdown = $('#site_header .navbar.navbar-default.margin-none').find('.dropdown.open').length > 0;

            if (isAboveBanner && !hasActiveDropdown && !isMouseOverHeader) {
                $stickyHeader.addClass('trasparent');

                if (logoColorType === 'dark') {
                    $logoImg.css('filter', 'none');
                }

                if (headerColor) {
                    $textElements.css('color', headerColor);
                    $svgPaths.css('fill', headerColor);
                    $hamburgerSpans.css('background-color', headerColor);
                }
            } else {
                $stickyHeader.removeClass('trasparent');

                $logoImg.css('filter', '');
                $textElements.css('color', '');
                $svgPaths.css('fill', '');
                $hamburgerSpans.css('background-color', '');
            }
        };

        $stickyHeader.on('mouseenter', function() {
            isMouseOverHeader = true;
            updateHeaderState();
        });

        $stickyHeader.on('mouseleave', function() {
            isMouseOverHeader = false;
            updateHeaderState();
        });

        $(window).on('scroll', updateHeaderState);
        $stickyHeader.on('shown.bs.dropdown hidden.bs.dropdown', updateHeaderState);

        updateHeaderState();
    }
});


$(document).ready(function() {
        const $stickyHeader = $('#site_header');

        const updateHeaderStateTrasparent = () => {
            const hasActiveDropdown = $('#site_header .navbar.navbar-default.margin-none').find('.dropdown.open').length > 0;
			if(hasActiveDropdown){
				$stickyHeader.addClass('hasActiveDropdown');
			}else{
				$stickyHeader.removeClass('hasActiveDropdown');
			}     
        };

        $('#site_header .navbar.navbar-default.margin-none').on('shown.bs.dropdown hidden.bs.dropdown', updateHeaderStateTrasparent);
        updateHeaderStateTrasparent();
    
});


// Animated Hamburger Icon, Open and Close navMobile
$('#nav-icon').click(function(e){
	$('#navbar-collapse-categories-mobile').click(); //Element clicked to trigger the below function that will close the menu automatically when a user clicks outside of it
	e.preventDefault();
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.navMobile').toggleClass('open');
	$('.search-dropdown').fadeToggle();
	$('.dropdown.cart').fadeToggle();
	$('.dropdown-lang').toggleClass('activemobile');
	if (document.body.style.overflow === 'hidden') {
		document.body.style.overflow = '';
	} else {
		document.body.style.overflow = 'hidden';
		var $stickyHeader = $('#site_header');
		$stickyHeader.removeClass('trasparent');
	}
});

$('#nav-icon-close').click(function(e){
	e.preventDefault();
	e.stopPropagation();
	$('#nav-icon').removeClass('open');
	$('.navMobile').toggleClass('open');
	document.body.style.overflow = '';
});

$('[data-zg-scrollTo="next"]').click(function(e) {
    e.preventDefault();
    console.log('NEXT');

    const scrollAmount = window.innerHeight; // 100vh
    $('html, body').animate({
        scrollTop: $(window).scrollTop() + scrollAmount
    }, 600); 
});

		

// DROPDOWN CHE SCENDE IN ALTEZZA E NON DI COLPO
$(document).ready(function() {
	$('.menuCnt .dropdown').on('show.bs.dropdown', function(e) {
		$(this).find('.dropdown-menu').first().stop(true, true).slideDown(250);
	});
	$('.menuCnt .dropdown').on('hide.bs.dropdown', function(e) {
		$(this).find('.dropdown-menu').first().stop(true, true).slideUp(100);
	});
});

$(document).ready(function() {
  var searchDropdown = $('.search-dropdown');
  searchDropdown.on('shown.bs.dropdown', function () {
    $(this).find('input[data-zg-role="search-input"]').focus();
  });
});


$(function() {
    setTimeout(function() {
        const $targets = $('.navbar-nav .dropdown:has(a.collapsable-sub-menu)');  
        $targets.each(function() {
            const $dropdownContainer = $(this);
            const $mainToggle = $dropdownContainer.find('> a.dropdown-toggle');        
            $dropdownContainer.addClass('open');
            $mainToggle.attr('aria-expanded', 'true');
            $dropdownContainer.find('.collapse').first().collapse('show');
        });
    }, 150);
});


